import { AntSelectOption, AntSelectPropsGeneric, AntSelectValue } from 'controls/react/ant/ant-select/types';
import { BaseOptionType } from '@rc-component/select/lib/Select';
import React from 'react';
import { SpaceHighlighter } from 'controls/ant/ant-select/components/space-highlighter/spaceHighlighter';

export function useTagsOptionRenderer<VT extends AntSelectValue, OptionType extends BaseOptionType>(
	props: AntSelectPropsGeneric<VT, OptionType>,
) {
	const { optionRender, mode, ...rest } = props;

	const tagOptionsRenderer = React.useMemo(() => {
		if ((mode != 'tags' && mode != 'multiple') || optionRender != null) {
			return optionRender;
		}

		return (option: AntSelectOption) => <SpaceHighlighter>{option.label}</SpaceHighlighter>;
	}, [optionRender, mode]);

	return {
		optionRender: tagOptionsRenderer,
		mode,
		...rest,
	};
}
